import { COCO_ROLE, VAULT, VAULT_ID } from "./constants";

function removeNullValues(obj) {
  return Object.fromEntries(
    Object.entries(obj).filter(
      ([key, value]) => value?.toLowerCase?.() !== "null" && value !== ""
    )
  );
}
function validProperties(obj) {
  return Object.fromEntries(
    Object.entries(obj).filter(([key, value]) => value)
  );
}

function replaceFalseyValuesWithEmptyString(obj) {
  for (const key in obj) {
    if (obj.hasOwnProperty(key) && !obj[key]) {
      obj[key] = "";
    }
  }
  return obj;
}

const removeURLQueryParams = (URL) => {
  return URL !== null && URL !== undefined && URL.length > 0
    ? URL.split("?")[0]
    : URL;
};
const getEmailUrlParams = (urlParams) => {
  try {
    const params = JSON.parse(
      '{"' +
        decodeURI(urlParams)
          .replace(/\\/g, '\\\\')
          .replace(/"/g, '\\"')
          .replace(/&/g, '","')
          .replace(/=/g, '":"') +
        '"}'
    );
    return removeNullValues({ ...params });
  } catch (e) {
    return {};
  }
};

const getUrlParams = () => {
  const urlParams = new URLSearchParams(
    globalThis.location.search || localStorage.getItem("urlParams")
  );
  const emailParams = getEmailUrlParams(urlParams);
  try {
    const params = {};
    for (const [key, value] of urlParams.entries()) {
      if (key.toLowerCase().includes("email") && emailParams?.[key]) {
        params[key] = decodeURIComponent(emailParams[key]);
      } else {
        params[key] = value;
      }
    }
    return removeNullValues({ ...params });
  } catch (e) {
    return {};
  }
};
const findFirstWithLargestLanguages = (arr) => {
  let maxLen = -1;
  let result = null;
  for (const obj of arr) {
    if (Array.isArray(obj.languages)) {
      if (obj.languages.length > maxLen) {
        maxLen = obj.languages.length;
        result = obj;
      }
    }
  }
  return result;
};

const cocoSourceSystems = ["VEEVA", "BALIOS", "VAULT"];

const isValidCocoSource = (source = "") => cocoSourceSystems?.includes(source);

const getUserById = (list, id) => list?.find((user) => user?.id === id);

const removeArrayObjectDuplicates = (arr, keysToCheck) => {
  const seen = new Set();
  return arr.filter((obj) => {
    const key = keysToCheck
      .map((key) => {
        const val = obj[key];
        return `${key}:${typeof val}:${val}`;
      })
      .join("|");

    if (seen.has(key)) {
      return false;
    } else {
      seen.add(key);
      return true;
    }
  });
};

const getSourceSystemId = (id) => {
  const sourceSystem = id?.toLowerCase();
  if (sourceSystem === VAULT) return VAULT_ID;
  else return sourceSystem;
};

const isUserHasAccessToPage = (accessPages, page) => {
  return accessPages?.includes(page);
};

const isRoleCOCO = (roles) => {
  if (typeof roles === "string") return roles === COCO_ROLE;
  else if (Array.isArray(roles)) return roles.includes(COCO_ROLE);
  return false;
};
export const currentEnv = (() => {
  const hostname = window.location.hostname;
  const match = hostname.match(/\.(development|staging)\./);
  return match ? match[1] : 'development';
})();

const titleCase = (str) =>
  str
    ?.toString()
    .toLowerCase()
    .split(" ")
    .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
    .join(" ");

export {
  getUrlParams,
  cocoSourceSystems,
  isValidCocoSource,
  getUserById,
  removeURLQueryParams,
  validProperties,
  replaceFalseyValuesWithEmptyString,
  findFirstWithLargestLanguages,
  removeArrayObjectDuplicates,
  getSourceSystemId,
  isRoleCOCO,
  isUserHasAccessToPage,
  titleCase,
};
